(function (ws) {
    'use strict';

    ws.views.customerOnboardingLogoutRequestModel = ws.views.modal.extend({
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .loggeOutCls': 'save',
            'click .noLoggedOutCls': 'close'
        }),

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
        },

        save: function (e) {
            this.eventAgg.trigger('saveAndContinueFunction', e);
        },

        close: function(e) {
            window.location.href = globals.path.api.westcon.logout;
        }
    });
}(westcon));
